// src/utils/ReactIntlWrapper.ts
import i18n from 'i18next';

const ReactIntlWrapper = {
  init: async (options: { currentLocale: string; locales: Record<string, any> }) => {
    const { currentLocale, locales } = options;

    await i18n.init({
      lng: currentLocale,
      fallbackLng: 'en',
      debug: false,
      resources: Object.keys(locales).reduce((acc, lang) => {
        acc[lang] = { translation: locales[lang] };
        return acc;
      }, {} as any),
      interpolation: {
        escapeValue: false, // React already escapes
      },
    });
  },

  get: (key: string, variables?: Record<string, any>) => {
    if (!key) {
      console.error(`Translation key is empty`);
      return "Key is not defined";
    }

    const translation = i18n.t(key, {
      ...variables,
      interpolation:{
        prefix: '{',
        suffix: '}',
      }
    });
    if (!translation || translation === key) {
      // Log si se quiere detectar claves faltantes
      console.warn(`Translation not found for key: ${key}`);
      return key;
    }

    return translation.toString();
  },

  has: (key: string) => {
    return i18n.exists(key);
  }
};

export default ReactIntlWrapper;
